<template>
  <div>
    <t-modal
      v-if="visibleFileManager && isThisFileManager"
      @close="() => closeFileManager()"
    >
      <template #custom-modal>
        <ImagePicker
          :key="JSON.stringify(options)"
          :options="options"
          :actual-path="fileManagerStore.defaultPath"
          @chooseFile="chooseFile"
          @closeFileManager="closeFileManager"
          @change-default-path="fileManagerStore.defaultPath = $event"
          @create-image="imageEditorStore.createNew = true"
          @notify="notify"
          @items-deleted="onItemsDeleted"
        />
      </template>
    </t-modal>

    <div class="flex justify-start gap-2">
      <t-button
        v-if="
          !modelValue ||
          modelValue ===
            'https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/pp1.png'
        "
        data-testid="section-choose-image"
        :xs="xs"
        @click="openFileManager"
      >
        <template #icon>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 5C2 3.90625 2.875 3 4 3H16C17.0938 3 18 3.90625 18 5V15C18 16.125 17.0938 17 16 17H4C2.875 17 2 16.125 2 15V5ZM12.0938 8.34375C11.9688 8.125 11.7188 8 11.5 8C11.25 8 11 8.125 10.875 8.34375L8.15625 12.3438L7.3125 11.2812C7.1875 11.125 6.96875 11 6.75 11C6.5 11 6.28125 11.125 6.15625 11.2812L4.15625 13.7812C3.96875 14.0312 3.9375 14.3438 4.0625 14.5938C4.1875 14.8438 4.4375 15 4.75 15H7.75H8.75H15.25C15.5 15 15.7812 14.875 15.9062 14.625C16.0312 14.375 16 14.0625 15.8438 13.8438L12.0938 8.34375ZM5.5 8C6.3125 8 7 7.34375 7 6.5C7 5.6875 6.3125 5 5.5 5C4.65625 5 4 5.6875 4 6.5C4 7.34375 4.65625 8 5.5 8Z"
              fill="currentColor"
            />
          </svg>
        </template>
        {{ $t("forms.image_choose") }}
      </t-button>
      <t-button
        v-if="
          modelValue &&
          showReplace &&
          modelValue !==
            'https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/pp1.png'
        "
        data-testid="section-choose-image"
        :xs="xs"
        @click="openFileManager"
      >
        <template #icon>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 5C2 3.90625 2.875 3 4 3H16C17.0938 3 18 3.90625 18 5V15C18 16.125 17.0938 17 16 17H4C2.875 17 2 16.125 2 15V5ZM12.0938 8.34375C11.9688 8.125 11.7188 8 11.5 8C11.25 8 11 8.125 10.875 8.34375L8.15625 12.3438L7.3125 11.2812C7.1875 11.125 6.96875 11 6.75 11C6.5 11 6.28125 11.125 6.15625 11.2812L4.15625 13.7812C3.96875 14.0312 3.9375 14.3438 4.0625 14.5938C4.1875 14.8438 4.4375 15 4.75 15H7.75H8.75H15.25C15.5 15 15.7812 14.875 15.9062 14.625C16.0312 14.375 16 14.0625 15.8438 13.8438L12.0938 8.34375ZM5.5 8C6.3125 8 7 7.34375 7 6.5C7 5.6875 6.3125 5 5.5 5C4.65625 5 4 5.6875 4 6.5C4 7.34375 4.65625 8 5.5 8Z"
              fill="currentColor"
            />
          </svg>
        </template>
        {{ $t("forms.image_change") }}
      </t-button>
      <t-button
        v-if="modelValue && showRemove"
        data-testid="remove-image"
        :xs="xs"
        @click="removeFile()"
      >
        <template #icon>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.2734 6.55859C15.7305 6.13672 15.7305 5.39844 15.2734 4.97656C14.8516 4.51953 14.1133 4.51953 13.6914 4.97656L10 8.66797L6.27344 4.97656C5.85156 4.51953 5.11328 4.51953 4.69141 4.97656C4.23438 5.39844 4.23438 6.13672 4.69141 6.55859L8.38281 10.25L4.69141 13.9766C4.23438 14.3984 4.23438 15.1367 4.69141 15.5586C5.11328 16.0156 5.85156 16.0156 6.27344 15.5586L10 11.8672L13.6914 15.5586C14.1133 16.0156 14.8516 16.0156 15.2734 15.5586C15.7305 15.1367 15.7305 14.3984 15.2734 13.9766L11.582 10.25L15.2734 6.55859Z"
              fill="currentColor"
            />
          </svg>
        </template>
        {{ $t("forms.image_remove") }}
      </t-button>
      <t-button
        v-if="showEditButton"
        :disabled="!modelValue"
        secondary
        data-testid="edit-image"
        :xs="xs"
        @click="editImage()"
      >
        <template #icon>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.2695 12.8125C13.0078 12.7031 13.6914 12.2656 14.1016 11.6367L18.5312 4.80078C18.8594 4.25391 18.7773 3.54297 18.3125 3.10547C17.8477 2.66797 17.1367 2.64062 16.6445 3.02344L10.1641 7.89062C9.50781 8.38281 9.125 9.14844 9.125 9.96875L12.2695 12.8125ZM11.7227 13.4961L8.55078 10.6523C6.91016 10.707 5.625 12.0469 5.625 13.6875C5.625 13.7969 5.625 13.9062 5.625 14.0156C5.67969 14.5078 5.35156 15 4.85938 15H4.75C4.25781 15 3.875 15.4102 3.875 15.875C3.875 16.3672 4.25781 16.75 4.75 16.75H8.6875C10.3555 16.75 11.75 15.3828 11.75 13.6875C11.75 13.6328 11.7227 13.5508 11.7227 13.4961Z"
              fill="currentColor"
            />
          </svg>
        </template>
        {{ $t("forms.image_edit") }}
      </t-button>
      <t-button
        v-if="showCreateButton"
        secondary
        data-testid="create-new-image"
        :xs="xs"
        @click="createNewImage()"
      >
        <template #icon>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.2695 12.8125C13.0078 12.7031 13.6914 12.2656 14.1016 11.6367L18.5312 4.80078C18.8594 4.25391 18.7773 3.54297 18.3125 3.10547C17.8477 2.66797 17.1367 2.64062 16.6445 3.02344L10.1641 7.89062C9.50781 8.38281 9.125 9.14844 9.125 9.96875L12.2695 12.8125ZM11.7227 13.4961L8.55078 10.6523C6.91016 10.707 5.625 12.0469 5.625 13.6875C5.625 13.7969 5.625 13.9062 5.625 14.0156C5.67969 14.5078 5.35156 15 4.85938 15H4.75C4.25781 15 3.875 15.4102 3.875 15.875C3.875 16.3672 4.25781 16.75 4.75 16.75H8.6875C10.3555 16.75 11.75 15.3828 11.75 13.6875C11.75 13.6328 11.7227 13.5508 11.7227 13.4961Z"
              fill="currentColor"
            />
          </svg>
        </template>
        {{ $t("forms.create_new_image") }}
      </t-button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import superEncodeURI from "@/utils/superEncodeURI";
  import { useImageEditorStore } from "@/stores/imageEditorStore";
  import { useFileManagerStore } from "@/stores/fileManger";
  import { useNotificationsStore } from "@/stores/notifications";

  import { formatBytes } from "@topol/utils";
  import { ImagePicker } from "@topol/image-picker";
  import type { FileOptions, IDeletedItem } from "@topol/image-picker";
  import { TModal, TButton } from "@topol/twig-ui";

  import { useI18n } from "vue-i18n";
  import { ref, computed, onMounted, onBeforeUnmount } from "vue";

  const props = defineProps({
    modelValue: {
      type: String,
      default: null,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    showRemove: {
      type: Boolean,
      default: false,
    },
    showReplace: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    xs: {
      type: Boolean,
      default: false,
    },
    // for the case when multiple images are managed in one form, e.g. carousel
    index: {
      type: Number,
      default: -1,
    },
  });

  const emit = defineEmits(["update:modelValue"]);

  const imageEditorStore = useImageEditorStore();
  const fileManagerStore = useFileManagerStore();
  const notificationsStore = useNotificationsStore();
  const t = useI18n().t;

  const editingThis = ref(false);

  const options = computed<FileOptions>(() => {
    return {
      ...fileManagerStore.FMOptions,
      imageCreation: imageEditorStore.enabled,
    };
  });

  const showEditButton = computed(() => {
    return imageEditorStore.enabled && props.showEdit && props.modelValue;
  });

  const showCreateButton = computed(() => {
    return imageEditorStore.enabled && props.showEdit && !props.modelValue;
  });

  const visibleFileManager = computed({
    get() {
      return fileManagerStore.visibleFileManager;
    },
    set(val: boolean) {
      fileManagerStore.visibleFileManager = val;
    },
  });

  // for the case when multiple images are managed in one form, e.g. carousel
  const isThisFileManager = computed(() => {
    if (props.index === -1) {
      return true;
    } else {
      return props.index === fileManagerStore.fileIndex;
    }
  });

  function chooseFile(url: string) {
    emit("update:modelValue", superEncodeURI(url));
    visibleFileManager.value = false;
  }

  function onItemsDeleted(items: IDeletedItem[]) {
    try {
      window.parent.postMessage(
        {
          type: "callback",
          action: "onImageDelete",
          data: {
            args: [items],
          },
        },
        "*"
      );
    } catch (error) {
      console.warn("[topol] onImageDelete postMessage failed", error);
    }
  }

  function removeFile() {
    emit("update:modelValue", null);
  }

  function editImage() {
    if (props.modelValue) {
      editingThis.value = true;
      imageEditorStore.photoEditorImage = props.modelValue;
    }
  }

  function createNewImage() {
    if (!props.modelValue) {
      editingThis.value = true;
      imageEditorStore.createNew = true;
    }
  }

  function openFileManager() {
    // Must run before the customFileManager early return so the echo handler
    // can route to the correct child index.
    const nextFileIndex = props.index !== -1 ? props.index : undefined;
    if (fileManagerStore.fileIndex !== nextFileIndex) {
      fileManagerStore.fileIndex = nextFileIndex;
    }

    if (fileManagerStore.customFileManager) {
      const message = {
        type: "callback",
        action: "onOpenFileManager",
        data: {},
      };
      return window.parent.postMessage(message, "*");
    }
    visibleFileManager.value = true;
  }

  function closeFileManager() {
    visibleFileManager.value = false;
    fileManagerStore.fileIndex = undefined;
  }

  const notificationsKeys = [
    {
      name: "invalid_folder_name",
      key: "file_manager.folder_name_invalid",
    },
    {
      name: "uploading_images_failed",
      text: "Uploading images failed",
    },
    {
      name: "selecting_images_failed",
      text: "Selecting images failed",
    },
    {
      name: "extension_error",
      key: "file_manager.extension_error",
    },
  ];

  function notify(name: string) {
    if (name.startsWith("upload_error:")) {
      notificationsStore.createNotification({
        text: t("file_manager.upload_error", {
          msg: name.slice("upload_error:".length),
        }),
        type: "error",
      });
      return;
    }

    if (name.startsWith("file_already_exists:")) {
      notificationsStore.createNotification({
        text: t("file_manager.file_name_exists", {
          msg: name.split(":")[1],
        }),
        type: "error",
      });
      return;
    }

    if (name.startsWith("folder_name_exists:")) {
      notificationsStore.createNotification({
        text: t("file_manager.folder_name_exists", {
          msg: name.split(":")[1],
        }),
        type: "error",
      });
      return;
    }

    if (name === "max_size_exceeded") {
      notificationsStore.createNotification({
        text: t("file_manager.max_size_exceeded", {
          size: formatBytes(fileManagerStore.imageMaxSize),
        }),
        type: "error",
      });
      return;
    }

    if (name.startsWith("limit-exceeded:")) {
      notificationsStore.createNotification({
        text: t("file_manager.max_uploading_files_exceeded", {
          count: fileManagerStore.preferences?.maxUploadingFiles,
          total: name.split(":")[1],
        }),
        type: "error",
      });
      return;
    }

    const thisMessage = notificationsKeys.find(
      (message) => message.name === name
    );
    if (!thisMessage) {
      return;
    }
    if (thisMessage.key) {
      notificationsStore.createNotification({
        text: t(thisMessage.key),
        type: "error",
      });
      return;
    }
    if (thisMessage.text) {
      notificationsStore.createNotification({
        text: thisMessage.text,
        type: "error",
      });
      return;
    }
  }

  function onChooseFileFromImageEditor(url: string) {
    if (editingThis.value) {
      chooseFile(url);
      editingThis.value = false;
    }
  }

  onMounted(() => {
    if (props.isOpen && !props.modelValue) {
      visibleFileManager.value = true;
    }

    window.$event.on("chooseFileFromImageEditor", onChooseFileFromImageEditor);
  });

  onBeforeUnmount(() => {
    window.$event.off("chooseFileFromImageEditor", onChooseFileFromImageEditor);
    visibleFileManager.value = false;
  });
</script>
